import React, { useState, useContext, useEffect } from "react"
import { AppContext } from "./index"
import CRUDriesgo from "./CRUDriesgo"

export default function Riesgo({ r }) {
    let { firebase } = useContext(AppContext)

    const [riesgo, setRiesgo] = useState(null)
    useEffect(() => { setRiesgo(firebase.riesgo(r)) }, [r, firebase])

    return (
        <div style={Smarco}>
            {riesgo && <CRUDriesgo riesgo={riesgo} />}
        </div>
    )
}

const Smarco = {
    margin: "25px",
    width: "36.2%",
};